module.exports = __webpack_public_path__ + "img/step13a_remove_top_cross_beam.440fdaed.png";